module.exports = __webpack_public_path__ + "static/restaurant_mayfair01-3097d927303ab43a4b5fb13fb6afa52b.jpg";